import request from '@/api/request.js'

// 新增
export function ArticleDetailInsert(data) {
    return request({
        url: '/api/article/articledetailinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function ArticleDetailDelete(id) {
    return request({
        url: `/api/article/articledetaildelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function ArticleDetailUpdate(id, data) {
    return request({
        url: `/api/article/articledetailupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function ArticleDetailGetById(id) {
    return request({
        url: `/api/article/getarticledetailbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function ArticleDetailGetList(params) {
    return request({
        url: '/api/article/getarticledetaillist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function ArticleDetailGetPageList(params) {
    return request({
        url: '/api/article/getarticledetailpagelist',
        method: 'get',
        params: params
    })
}